import { useState } from 'react'

import { Box, Typography } from '@material-ui/core'

import { StartAtInput } from './StartAtInput'
import { NotAvailableMessage } from './NotAvailableMessage'

import { LinkTemplates } from 'UI/Components/Dialogs/ShareDialog/ShareLink'

import { PlaybookType } from 'app/types'

import { timeToSeconds } from 'modules'
import { useBoolean } from 'hooks'

type Props = {
    playbook: PlaybookType
}

export const TrackTab = ({ playbook }: Props) => {
    const [startTime, setStartTime] = useState('00:00:00')

    const startAt = useBoolean()

    return (
        <Box position="relative">
            {!playbook.isPublic && <NotAvailableMessage />}
            <StartAtInput startTime={startTime} setStartTime={setStartTime} startAt={startAt} />
            <Box my={1.5}>
                <Typography color="textSecondary" style={{ fontSize: '14px' }}>
                    Share tracking links to help you track the activity when users watch public
                    content
                </Typography>
            </Box>
            <LinkTemplates playbook={playbook} startAt={timeToSeconds(startTime)} appsOnly={true} />
        </Box>
    )
}
